import Flickity from 'flickity/dist/flickity.pkgd.min';
export default {
  init() {
    // JavaScript to be fired on the about us page

    const id = document.querySelector('body').getAttribute('data-id');
    let voted = false;

    if (sessionStorage.postVoted === undefined) {
      voted = false;
    } else if (sessionStorage.postVoted.includes(id)) {
      $('.js--like').toggleClass('selected');
      voted = true;
    } else {
      voted = false;
    }

    let likeTrigger = document.querySelector('.js--like');
    let likeCount = likeTrigger.parentElement.querySelector('.likes-count');

    likeTrigger.addEventListener('click', () => {
      if(voted == false) {
        $.ajax({
          url: location.origin + '/wp-admin/admin-ajax.php',
          data: {post: id, action: 'updateLikes' },
          type: 'POST',
          beforeSend: function () {
          },
          success: function (res) {
            likeCount.innerHTML = res;

            if (sessionStorage.postVoted === undefined || sessionStorage.postVoted === '') {
              sessionStorage.postVoted = id;
            } else {
              let votes = sessionStorage.postVoted.split(',');
              votes.push(id);
              sessionStorage.postVoted = votes;
            }
            voted = true;

            $('.js--like').toggleClass('selected');
            $('.js--like').toggleClass('active');

            setTimeout(() => {
              $('.js--like').toggleClass('active');
            }, 2000);

          },
          error: function () {
            console.log('KO');
          },
        });
      }
    });

    let viewTrigger = document.querySelector('.js--view');
    let viewCount = viewTrigger.parentElement.querySelector('.views-count');

    window.addEventListener('load', () => {
        $.ajax({
          url: location.origin + '/wp-admin/admin-ajax.php',
          data: {post: id, action: 'updateVisits' },
          type: 'POST',
          beforeSend: function () {
          },
          success: function (res) {
            viewCount.innerHTML = res;
          },
          error: function () {
            console.log('KO');
          },
        });
    });
  },
};





// WEBPACK FOOTER //
// ./scripts/routes/single-post.js